export const WORDS = [
  "AGENT",
  "WORLD",
  "ABOUT",
  "HEART",
  "WATER",
  "SIXTY",
  "BOARD",
  "MONTH",
  "MUSIC",
  "PARTY",
  "PIANO",
  "MOUTH",
  "WOMAN",
  "SUGAR",
  "AMBER",
  "DREAM",
  "LAUGH",
  "TIGER",
  "EARTH",
  "MONEY",
  "WORDS",
  "SMILE",
  "LEMON",
  "SOUTH",
  "AFTER",
  "STONE",
  "THING",
  "LIGHT",
  "STORY",
  "POWER",
  "TODAY",
  "RANGE",
  "PEARL",
  "VENOM",
  "PROXY",
  "ROUND",
  "HOVER",
  "CANDY",
  "ABOVE",
  "PHONE",
  "OTHER",
  "SMART",
  "BLACK",
  "MAGIC",
  "FRUIT",
  "RADIO",
  "ROYAL",
  "HONEY",
  "FLAKE",
  "SOUND",

  // Additional words (duplicates and non-5-letter words removed)
  "BEACH",
  "CLOUD",
  "DANCE",
  "EMAIL",
  "FRESH",
  "HOUSE",
  "IMAGE",
  "JUICE",
  "KNIFE",
  "LEARN",
  "METAL",
  "NIGHT",
  "OCEAN",
  "PAINT",
  "QUIET",
  "ROBOT",
  "SLEEP",
  "TABLE",
  "UNDER",
  "VIDEO",
  "WATCH",
  "YOUNG",
  "APPLE",
  "BRAIN",
  "CHAIR",
  "DRESS",
  "EAGLE",
  "FLAME",
  "GRASS",
  "HAPPY",
  "IVORY",
  "JELLY",
  "LUCKY",
  "MOVIE",
  "NURSE",
  "OLIVE",
  "PEACE",
  "RIVER",
  "SPACE",
  "TRAIN",
  "UNITY",
  "VOICE",
  "WHITE",
  "BREAD",
  "CLOCK",
  "DAIRY",
  "EARLY",
  "FAITH",
  "GHOST",
  "HOTEL",
  "MODEL",
  "NORTH",
  "OPERA",
  "PAPER",
  "QUICK",
  "SHARK",
  "TASTE",
  "UNCLE",
  "VALUE",
  "WASTE",
  "XEROX",
  "YIELD",
  "AZURE",
  "BROWN",
  "CRAFT",
  "DRINK",
  "EVERY",
  "FROST",
  "GRAND",
  "HONOR",
  "INNER",
  "JUDGE",
  "KNOWN",
  "LEVEL",
  "MAJOR",
  "NOBLE",
  "ORDER",
  "PRICE",
  "QUOTE",
  "RIGHT",
  "STYLE",
  "THEME",
  "URBAN",
  "VISTA",
  "BLOOM",
  "CHARM",
  "DEPTH",
  "EXACT",
  "FOCUS",
  "GRACE",
  "IDEAL",
  "KNEEL",
  "LOGIC",
  "MARCH",
  "NERVE",
  "PULSE",
  "QUEST",
  "RELAX",
  "SCALE",
  "TRADE",
  "UNIFY",
  "VERSE",
  "WORTH",
  "BLEND",
  "CURVE",
  "DELTA",
  "EQUAL",
  "FAULT",
  "GUIDE",
  "INPUT",
  "LASER",
  "MERIT",
  "NOISE",
  "ORBIT",
  "PLANT",
  "QUERY",
  "RAPID",
  "SHINE",
  "TOUCH",
  "VALID",
  "BRAKE",
  "CLEAN",
  "DRIVE",
  "ENTER",
  "FLASH",
  "GRAPE",
  "MOUNT",
  "PLANE",
  "RAISE",
  "ALIVE",
  "BRAVE",
  "CLAIM",
  "DRAFT",
  "ERROR",
  "FLUID",
  "GREEN",
  "HEAVY",
  "INDEX",
  "JOLLY",
  "KEEPS",
  "MATCH",
  "NEVER",
  "OFFER",
  "POINT",
  "READY",
  "SHARE",
  "THINK",
  "ARGUE",
  "BUILD",
  "CARRY",
  "EMPTY",
  "FIRST",
  "GUEST",
  "LARGE",
  "MANGE",
  "PRINT",
  "SERVE",
  "USING",
  "WRITE",
  "BASIC",
  "CATCH",
  "DOUBT",
  "EVENT",
  "FIELD",
  "GREAT",
  "ISSUE",
  "ROGER",
  "SPEED",
  "TRACE",
  "AUDIT",
  "BRING",
  "CHESS",
  "FLOOD",
  "GRAIN",
  "LUNCH",
  "NINJA",
  "OLDER",
  "PLACE",
  "THROW",
  "VITAL",
  "WHEEL",
  "ANGER",
  "BEAST",
  "CHAIN",
  "GLOBE",
  "KAYAK",
  "MAPLE",
  "NOVEL",
  "QUART",
  "ROUGH",
  "SWEET",
  "VAULT",
  "YEAST",
  "ALERT",
  "LIMIT",
  "PLAIN",
  "STAND",
  "TRUST",
];
